import { checkDomainAllowFetchDataConfig } from 'components/common/func';
import { useEffect } from 'react';

const checkLoadJSDuplicated = (src, type) => {
  if (window !== 'undefined') {
    const jss = Array.from(document.head.getElementsByTagName('script'));

    if (jss.length) {
      return jss.find((js) => js.getAttribute('src') === src);
    }
  }

  return false;
};

const useLoadJS = (src, type) => {
  useEffect(() => {
    if (!checkDomainAllowFetchDataConfig()) return;

    if (src && !checkLoadJSDuplicated(src)) {
      var script = document.createElement('script');
      script.src = src;
      if (type) {
        script.type = type;
      }

      document.head.appendChild(script);
    }
  }, [src]);
};

export default useLoadJS;
